module.exports = __webpack_public_path__ + "img/poster-en80x40.c2fa7b2d.jpg";